import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Navbar, Sidebar, Footer } from './components'
import { Home, About, Psicotherapy, Publications, Contacts, Error } from './pages'
import ScrollToTop from "./utils/scrollToTop";

import './App.css';



function App() {
  return (
    <Router>
        <Navbar />
        <Sidebar />
        {/* tive que usar este component para as páginas fazerem scroll to top em cada link NOTA_ o react router já não faz isso */}
        <ScrollToTop>
            <Routes>
                <Route exact path="/" element={<Home/>} />
                <Route exact path="/sobre" element={<About/>} />
                <Route exact path="/psicoterapia" element={<Psicotherapy/>} />
                <Route exact path="/publicacoes" element={<Publications/>} />
                <Route exact path="/contactos" element={<Contacts/>} />
                <Route path="*" element={<Error/>} />
            </Routes>
        </ScrollToTop>
        <Footer />
    </Router>
  );
}

export default App;
